import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { TFunction } from 'i18next';
import { StateType } from 'domain/types/base/base';
import { CAMPANHAS_PEDIDORESGATE_LOTE, CAMPANHAS_USUARIO_ALL } from '../../../types/campanha/campanhas';
import { AppThunk, DispatchPaged, DispatchPagedReset } from 'base/src/utils/reducerUtil';
import { CampanhasService } from '../../../services/campanha/campanhasService';
import { PagedListRequest } from 'domain/types/global/pagedListRequest';
import { CampanhaPedidoResgateResponse } from '../../../types/campanha/campanhaPedidoResgateResponse';
import { PagedListResponse } from 'domain/types/global/pagedListResponse';
import { toast } from 'react-toastify';

const _CampanhaService = new CampanhasService();

export function GetCampanhasByUsuario(usuarioId: number, empresaId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(CAMPANHAS_USUARIO_ALL, DispatchType.LOADING, 'Carregando', StateType.Master))
    // const asyncResponse = await _CampanhaService.GetCampanhaByUsuario(5389, 117);
    const asyncResponse = await _CampanhaService.GetAtivosByUsuarioPagador(usuarioId, empresaId);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: CAMPANHAS_USUARIO_ALL
      })

      callback();

      dispatch(DispatchLoading(CAMPANHAS_USUARIO_ALL, DispatchType.SUCCESS));
    }
  }
}

export function GetPedidoResgateByLote(loteId: number, campanhaId: number, request: PagedListRequest<CampanhaPedidoResgateResponse>, t: TFunction): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(CAMPANHAS_PEDIDORESGATE_LOTE, DispatchType.LOADING, t("Carregando"), StateType.Local))

    request.data = { CampanhaPedidoResgatePagamentoID: loteId } as CampanhaPedidoResgateResponse;

    const asyncResponse = await _CampanhaService.GetPedidoResgatesByLote(loteId, campanhaId, request)

    if (ResponseValid(asyncResponse)) {
      const paged = (asyncResponse as PagedListResponse<CampanhaPedidoResgateResponse>)
      dispatch(DispatchPaged<CampanhaPedidoResgateResponse>(CAMPANHAS_PEDIDORESGATE_LOTE, request, paged))
    } else {
      dispatch(DispatchLoading(CAMPANHAS_PEDIDORESGATE_LOTE, DispatchType.ERROR, t("Erro"), StateType.Local))
    }
  };
}

export function GetComprovantePdf(campanhaId: number, tranferenciaId: number, t: TFunction): AppThunk {
  return async () => {
    try {
      const asyncResponse = await _CampanhaService.GetComprovantePdf(campanhaId, tranferenciaId);

      if (ResponseValid(asyncResponse)) {
        const blob = asyncResponse as Blob;
        const url = URL.createObjectURL(blob);

        const newWindow = window.open(url, "_blank");
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          toast(t("O comprovante não pôde ser aberto automaticamente. Por favor, permita popups para este site."));
          return url; // Return URL for manual download
        }
      } else {
        toast(t("Erro ao baixar comprovante"));
      }
    } catch (error) {
      toast(t("Erro ao processar comprovante"));
    }
  };
}

export function ResetLoteDetalhe(request: PagedListRequest<CampanhaPedidoResgateResponse>, take: number): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchPagedReset<CampanhaPedidoResgateResponse>(CAMPANHAS_PEDIDORESGATE_LOTE, request, take))
  }
}

